import * as React from "react";

export type BadgeItem = {
  background: string;
  title: string;
  text: string;
  css_class: string;
};

export type BadgesProps = {
  badgeItems: BadgeItem[];
};

export const Badges = ({ badgeItems }: BadgesProps): JSX.Element => (
  <ul
    className="badges"
    style={{ position: "absolute", top: "106px", left: 0 }}
  >
    {badgeItems.map((badge) => (
      <li
        style={{ marginBottom: "13px" }}
        key={badge.text}
        className={badge.css_class}
      >
        <span
          className={badge.css_class}
          style={{
            backgroundColor: badge.background,
            color: "white",
            fontWeight: "bold",
            fontSize: "15px",
            padding: "2px 5px",
          }}
          title={badge.title}
        >
          {badge.text}
        </span>
      </li>
    ))}
  </ul>
);
